module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1P3cM"))).then(() => parcelRequire('hEqeo'));